import { useEffect, useState } from 'react';

import { useCustomContext, usePostman } from '../../showcase-react';

export function useParams(): Record<string, string | undefined> {
  const postman = usePostman();
  const context = useCustomContext();

  const [value, setValue] = useState<Record<string, string | undefined>>(
    context?.router?.params ?? {},
  );

  useEffect(() => {
    const router = postman?.accept('lke/router', (result: { params: any }) => {
      const { params } = result;

      setValue(params);
    });

    return () => {
      router?.remove();
    };
  }, [postman]);

  return value;
}
